"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var add_click_listener_for_attr_1 = __importDefault(require("../../utils/add-click-listener-for-attr"));
var patternPickerEl = document.getElementById('pdp-pattern-picker');
if (patternPickerEl) {
    var selectPattern = function (pattern, target, opts) {
        Array.from(patternPickerEl.querySelectorAll('[data-pattern]')).forEach(function (el) { return el.classList.remove('border-sea-pink'); });
        target.classList.add('border-sea-pink');
        Array.from(patternPickerEl.querySelectorAll('[data-pattern-title], [data-pattern-description], [data-pattern-image]')).forEach(function (el) { return (el.style.display = 'none'); });
        var titleEl = patternPickerEl.querySelector("[data-pattern-title=\"".concat(pattern, "\"]"));
        var descriptionEl = patternPickerEl.querySelector("[data-pattern-description=\"".concat(pattern, "\"]"));
        var imageEl = patternPickerEl.querySelector("[data-pattern-image=\"".concat(pattern, "\"]"));
        if (titleEl) {
            titleEl.style.display = 'block';
        }
        if (descriptionEl) {
            descriptionEl.style.display = 'block';
        }
        if (imageEl) {
            imageEl.style.display = 'block';
        }
        if (!opts || opts.scrollToImage !== false) {
            window.scrollTo({ top: patternPickerEl.offsetTop - 80, behavior: 'smooth' });
        }
    };
    // process pattern on click and at page load
    (0, add_click_listener_for_attr_1.default)('data-pattern', selectPattern);
    var firstPatternEl = document.querySelector('[data-pattern]');
    if (firstPatternEl) {
        selectPattern(firstPatternEl.getAttribute('data-pattern') || '', firstPatternEl, { scrollToImage: false });
    }
}
